import { render, staticRenderFns } from "./AssertiveYieldTokens.vue?vue&type=template&id=512e5fb8&scoped=true"
import script from "./AssertiveYieldTokens.vue?vue&type=script&lang=js"
export * from "./AssertiveYieldTokens.vue?vue&type=script&lang=js"
import style0 from "./AssertiveYieldTokens.vue?vue&type=style&index=0&id=512e5fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e5fb8",
  null
  
)

export default component.exports